import _toConsumableArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useState } from "react";
import { IconSearch, TaggedInput } from "@catchoftheday/cg-components";
import { SEARCH_FACET_FILTERED_DISPLAY_AMOUNT, SEARCH_FACET_TYPE_KEYED_LIST } from "@search-app/helpers/search/search.helpers.facets";
import { SEARCH_URL_PARAM_FACET } from "@search-app/helpers/search/search.helpers.params";
import { facetAppliedCount } from "@search-app/utilities/facets/applied";
import getCols from "@search-app/utilities/search/search.utilities.getCols";
import getSelectedNames from "@search-app/utilities/search/search.utilities.getSelectedNames";
import { FacetList } from "../../SearchFacets.styles";
import { SearchFacetsBody } from "../SearchFacetsBody";
import { SearchFacetsContainer } from "../SearchFacetsContainer";
import { SearchFacetsHeader } from "../SearchFacetsHeader";
import { SearchFacetsKeyTabs } from "../SearchFacetsKeyTabs";
import { SearchFacetsListItem } from "../SearchFacetsListItem";
import { NoResults } from "../SearchFacetsNoResults";
import { ShowMore } from "../SearchFacetsShowMore/SearchFacetsShowMore";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var flattenValues = function flattenValues(values) {
  var flatValues = _objectSpread({}, values);

  return Object.keys(flatValues).reduce(function (acc, tabKey) {
    flatValues[tabKey].forEach(function (tabValues) {
      if (Object.isExtensible(tabValues)) {
        Object.assign(tabValues, {
          tabKey: tabKey
        });
      }
    });
    acc.push.apply(acc, _toConsumableArray(flatValues[tabKey]));
    return acc;
  }, []);
};
export var getflattenValuesLength = function getflattenValuesLength(values) {
  return Object.values(values).reduce(function (acc, tabValues) {
    return acc + tabValues.length;
  }, 0);
};
export var hasSearchDigit = function hasSearchDigit(name, searchBarTerm) {
  var aNumPart = name.replace(/\D/g, "");
  var bNumPart = searchBarTerm.replace(/\D/g, "");
  return aNumPart.includes(bNumPart);
};
export var hasSearchString = function hasSearchString(name, searchBarTerm) {
  var aStrPart = name.replace(/[^a-zA-Z]/g, "").toLowerCase();
  var bStrPart = searchBarTerm.replace(/[^a-zA-Z]/g, "").toLowerCase();
  return aStrPart.includes(bStrPart);
};
export var getUnselectedFilteredValues = function getUnselectedFilteredValues(searchBarTerm, unselectedValues, flattenedUnselectedValues, activeTabName) {
  //  set filter range
  var filterFromValues = [];

  if (activeTabName !== "" && unselectedValues[activeTabName]) {
    filterFromValues = unselectedValues[activeTabName];
  } else {
    filterFromValues = flattenedUnselectedValues;
  } //  compare searchBarTerm


  if (searchBarTerm === "") {
    return filterFromValues;
  }

  return filterFromValues.filter(function (value) {
    return hasSearchDigit(value.name, searchBarTerm) && hasSearchString(value.name, searchBarTerm);
  });
};
export var SearchFacetsKeyedList = function SearchFacetsKeyedList(_ref) {
  var facet = _ref.facet,
      isClearAll = _ref.isClearAll,
      isExpanded = _ref.isExpanded,
      _ref$hardCodedCols = _ref.hardCodedCols,
      hardCodedCols = _ref$hardCodedCols === void 0 ? 0 : _ref$hardCodedCols,
      onClear = _ref.onClear,
      onChange = _ref.onChange,
      onExpandChange = _ref.onExpandChange,
      noncollapsible = _ref.noncollapsible,
      scrollable = _ref.scrollable,
      searchTimeout = _ref.searchTimeout;
  var id = facet.id,
      name = facet.name,
      values = facet.values;
  var facetId = "".concat(SEARCH_URL_PARAM_FACET, "[").concat(id, "]");
  var inputRef = /*#__PURE__*/React.createRef();

  var _useState = useState(-1),
      filteredListFocusIndex = _useState[0],
      setFilteredListFocusIndex = _useState[1];

  var _useState2 = useState(""),
      searchBarTerm = _useState2[0],
      setSearchBarTerm = _useState2[1];

  var _useState3 = useState(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT),
      filteredDisplayAmount = _useState3[0],
      setFilteredDisplayAmount = _useState3[1];

  var _useState4 = useState(Object.values(values).reduce(function (acc, tabValues) {
    var tabSelectedValues = tabValues.filter(function (value) {
      return value.selected;
    }).map(function (value) {
      return _objectSpread({}, value);
    });
    acc.push.apply(acc, _toConsumableArray(tabSelectedValues));
    return acc;
  }, [])),
      selectedValues = _useState4[0],
      setSelectedValues = _useState4[1];

  var _useState5 = useState(scrollable && Object.keys(values).length ? Object.keys(values)[0] : ""),
      activeTabName = _useState5[0],
      setActiveTabName = _useState5[1];

  var actualDisplayLength = 0;

  var initActiveTabName = function initActiveTabName() {
    if (scrollable && Object.keys(values).length) {
      setActiveTabName(Object.keys(values)[0]);
    } else {
      setActiveTabName("");
    }
  };

  useEffect(function () {
    if (isClearAll) {
      //  reset all state
      setSelectedValues([]);
      setFilteredListFocusIndex(-1);
      setSearchBarTerm("");
      setFilteredDisplayAmount(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
      initActiveTabName();
    } else {
      var updatedSelectedValues = _toConsumableArray(flattenValues(values).filter(function (value) {
        return value.selected;
      }));

      setSelectedValues(updatedSelectedValues); //  update activeTabName

      if (activeTabName.length > 0 && Object.keys(values).findIndex(function (key) {
        return key === activeTabName;
      }) === -1) {
        initActiveTabName();
      }
    }
  }, [values, isClearAll]);
  var unselectedValues = values;
  var flattenedUnselectedValues = flattenValues(unselectedValues);
  var unselectedFilteredValues = [];
  var selectedNames = getSelectedNames(selectedValues);
  var onClearHandler = useCallback(function () {
    if (onClear) {
      setSelectedValues([]);
      onClear({
        facet: id
      });
    }
  }, [onClear, id]);
  var toggleValues = useCallback(function (tag, select) {
    onChange({
      facet: id,
      value: tag.id,
      type: SEARCH_FACET_TYPE_KEYED_LIST
    });

    if (select) {
      setSearchBarTerm("");
      setFilteredListFocusIndex(-1);
      setFilteredDisplayAmount(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
    }
  }, [onChange, id]);
  var onTagInputChange = useCallback(function (event) {
    setSearchBarTerm(event.target.value);
    setFilteredListFocusIndex(-1);
    setFilteredDisplayAmount(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
  }, []); // Upon user hitting 'Enter', clear input search and update values

  var onTagInputBtnKeyDown = function onTagInputBtnKeyDown(event) {
    if (event.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();

      if (unselectedFilteredValues.length === 0 || filteredListFocusIndex === -1) {
        return;
      }

      toggleValues(unselectedFilteredValues[filteredListFocusIndex], true);
      return;
    } // Upon user hitting 'Escape', clear input search


    if (event.keyCode === 27 || event.key === "Escape") {
      event.preventDefault();
      setSearchBarTerm("");
      setFilteredListFocusIndex(-1);
      return;
    } // Handle when user hits up or down arrow to select facet value


    if (event.keyCode === 40 || event.key === "ArrowDown") {
      event.preventDefault();

      if (filteredListFocusIndex !== actualDisplayLength - 1) {
        setFilteredListFocusIndex(filteredListFocusIndex + 1);
      }

      return;
    }

    if (event.keyCode === 38 || event.key === "ArrowUp") {
      event.preventDefault();

      if (filteredListFocusIndex !== 0) {
        setFilteredListFocusIndex(filteredListFocusIndex - 1);
      }

      return;
    }

    if (event.keyCode === 46 || event.keyCode === 8 || event.key === "Delete") {
      if (searchBarTerm.length === 0 && selectedValues.length > 0) {
        toggleValues(selectedValues[selectedValues.length - 1], 0);
      }
    }
  };

  var showMore = function showMore() {
    var _window$cotd;

    setFilteredDisplayAmount(filteredDisplayAmount + SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);

    if (filteredListFocusIndex !== -1) {
      setFilteredListFocusIndex(filteredListFocusIndex + SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
    }

    if (!((_window$cotd = window.cotd) !== null && _window$cotd !== void 0 && _window$cotd.isMobileWeb) && inputRef.current) {
      inputRef.current.focus({
        preventScroll: true
      });
    }
  };

  var getFilteredResult = function getFilteredResult(displayedValues, hasSearchBar) {
    if (displayedValues.length <= 0) {
      return ___EmotionJSX(NoResults, null);
    }

    return displayedValues.map(function (value, index) {
      var count = value.count,
          display = value.display,
          id = value.id,
          name = value.name,
          selected = value.selected,
          tabKey = value.tabKey;
      var facetItemId = "".concat(facetId, "-").concat(id);
      var displayName = tabKey && tabKey.length === 2 && !name.includes(tabKey) ? "".concat(tabKey, " ").concat(name) : name;
      var hidden = index >= filteredDisplayAmount;
      var focused = hasSearchBar && filteredListFocusIndex === index;
      var cols = getCols(hardCodedCols, displayedValues);

      if (hidden) {
        return null;
      }

      return ___EmotionJSX(SearchFacetsListItem, {
        checked: selected,
        count: count,
        display: display,
        id: facetItemId,
        key: facetItemId,
        label: displayName,
        onChange: toggleValues,
        value: value,
        columns: cols,
        focused: focused,
        padding: "0 16px"
      });
    });
  };

  var onSwitchTab = function onSwitchTab(tabName) {
    if (activeTabName === tabName) {
      setActiveTabName("");
    } else {
      setActiveTabName(tabName);
    }
  };

  var hasSearchBar = false;
  var displayedValues = [];
  var hasShowMore = false;
  var tabNames = Object.keys(values);
  /* if there are multiple tabs, always show search bar because it's
  hard to categorize unavailable selected values in any tab */

  if (tabNames.length > 1 || tabNames.length <= 1 && getflattenValuesLength(values) > SEARCH_FACET_FILTERED_DISPLAY_AMOUNT) {
    hasSearchBar = !scrollable;
    unselectedFilteredValues = getUnselectedFilteredValues(searchBarTerm, unselectedValues, flattenedUnselectedValues, activeTabName);
    displayedValues = unselectedFilteredValues;
  } else {
    displayedValues = flattenValues(values);
  }

  if (displayedValues.length > filteredDisplayAmount) {
    hasShowMore = true;
    actualDisplayLength = filteredDisplayAmount;
  } else {
    actualDisplayLength = displayedValues.length;
  }

  var filteredResults = getFilteredResult(displayedValues, hasSearchBar);
  var totalSelected = facetAppliedCount(facet);
  return ___EmotionJSX(SearchFacetsContainer, {
    id: facetId
  }, ___EmotionJSX(SearchFacetsHeader, {
    id: facetId,
    isExpanded: isExpanded,
    title: name,
    searchTimeout: searchTimeout,
    selectedLabel: selectedNames,
    onClear: onClearHandler,
    onExpandChange: onExpandChange,
    noncollapsible: noncollapsible,
    totalSelected: totalSelected
  }), ___EmotionJSX(SearchFacetsBody, {
    isExpanded: isExpanded
  }, hasSearchBar && ___EmotionJSX(TaggedInput, {
    ref: inputRef,
    prefixIcon: IconSearch,
    onChange: onTagInputChange,
    onKeyDown: onTagInputBtnKeyDown,
    onRemoveTag: function onRemoveTag(id) {
      return toggleValues({
        id: id
      }, false);
    },
    placeholder: "Search ".concat(name),
    value: searchBarTerm,
    containerProps: {
      mb: "15px"
    },
    fontSize: {
      xs: "base",
      md: "sm"
    },
    labelText: "Search ".concat(name)
  }), ___EmotionJSX(SearchFacetsKeyTabs, {
    tabNames: tabNames,
    activeTabName: activeTabName,
    onKeyDown: onTagInputBtnKeyDown,
    onSwitchTab: onSwitchTab
  }), ___EmotionJSX(FacetList, null, filteredResults), hasShowMore && !scrollable && ___EmotionJSX(ShowMore, {
    onClickHandler: showMore
  })));
};